<script lang="ts">
    import { onDestroy } from 'svelte'

    import Icon from '@iconify/svelte'

    import { get, writable } from 'svelte/store'
    import { slide } from 'svelte/transition'
    import { resolve } from 'hydria/services/gettext'

    import Item from './Item.svelte'

    let { item } = $props()

    let collapsed = $state(item.collapsed === true)

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    const subitems = writable([] as any)

    // No need to debounce: svelte only calls this once
    function updateSubitems() {
        const res: any[] = []
        for (const subitem of item.items) {
            if (subitem.condition == null || get(subitem.condition)) {
                res.push(subitem)
            }
        }
        subitems.set(res)
    }

    for (const subitem of item.items) {
        if (subitem.condition != null) {
            unsubs.push(subitem.condition.subscribe(updateSubitems))
        }
    }
    updateSubitems()
</script>

{#if $subitems.length}
    <div class="nav-group" class:closed={collapsed} class:open={!collapsed}>
        <a
            onclick={(e) => {
                e.preventDefault()
                collapsed = !collapsed
            }}
            href={'#'}
            class="ng-title"
        >
            <span class="ng-title-text">{$resolve(item.name)}</span>
            <span class="ng-title-icon"><Icon inline icon={collapsed ? 'fa:chevron-left' : 'fa:chevron-down'} /></span>
        </a>
        {#if !collapsed}
            <div transition:slide|local class="nav nav-stacked">
                {#each $subitems as subitem (subitem.id)}
                    <Item item={subitem} />
                {/each}
            </div>
        {/if}
    </div>
{/if}
